<template>
  <MessageOverlaySkeleton
    v-if="messages"
    class="gw_mesblock_container"
    :isBlurred="true"
    :isTopDown="true"
    style="--content-margin: auto auto auto auto; --back-from: transparent"
    data-tst="ratable_message_default}"
  >
    <MessagesGoPostflop
      :namespace="namespace"
      :hasShortcutBtn="hasShortcutBtn"
      :canAISolve="canAISolve"
      :posflopContent="$t(`tabs.${showProp}`)"
    />

    <div
      v-if="!showFlopContent"
      class="gw_boxs flex-1 mt-2"
    >
      <div class="text_tab_small mb-1">
        {{ $t('common.available_preflop_strategy_options') }}
      </div>
      <UnSwitcherNew
        :hasText="true"
        :isInside="true"
        :asMenu="asMenu"
        :hiddenOptions="hiddenOptions"
        :options="options"
        :translatePath="translatePath"
        style="--gwbtns-wrap: wrap"
        :hasNamedSelectedSlot="true"
        :hasNamedDefaultSlot="true"
      >
        <template #selected_swv_ev>
          {{ showEvIn === 'pot' ? 'EV/POT%' : 'EV' }}
        </template>
        <template #default_swv_ev>
          {{ showEvIn === 'pot' ? 'EV/POT%' : 'EV' }}
        </template>
      </UnSwitcherNew>
    </div>
  </MessageOverlaySkeleton>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import MessagesGoPostflop from '@/components/Poker/Overlays/Messages/MessagesGoPostflop'

export default {
  name: 'MessagesRangeTable2',
  components: {
    MessageOverlaySkeleton,
    MessagesGoPostflop,
    UnSwitcherNew,
  },
  props: {
    namespace: { required: true, type: String },
    canAISolve: { required: true, type: Boolean },
    showProp: String,
    isHero: {
      type: Boolean,
      default: false,
    },
    translatePath: String,
    showFlopContent: Boolean,
    showEvIn: String,
    hasShortcutBtn: { type: Boolean, default: true },
    hasAvailableOptionsHint: { type: Boolean, default: true },
    hiddenOptions: {
      type: Array,
      default: () => ['eq', 'eqr', 'ev', 'strategy_eq', 'swv_eq', 'swv_eqr'],
    },
    options: {
      type: Array,
      default: () => [],
    },
    asMenu: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    // Determine if we should show messages
    messages() {
      if (!this.showProp) return null

      if (!this.showFlopContent) {
        const posflopOpts = this.isHero ? ['eq', 'eqr', 'strategy_eq'] : ['ev', 'eq', 'eqr']

        if (posflopOpts.some(i => this.showProp === i)) {
          return ['postflop_only']
        }
      }

      return null
    },
  },
}
</script>
